import { PricingPlan } from '@css-xp/graphtypes/src/generated-types-new';
import defaultTo from 'lodash/defaultTo';
import get from 'lodash/get';

export const useGetMaxUsersForOrderEstimate = (): {
  getMaxUsersForOrderEstimate: (
    pricingPlan: PricingPlan,
    maxUsersForCurrentOffering: number
  ) => number | undefined | null;
} => {
  /**
   * This function figures out the max permissible number of users so that order estimate response has all the
   * required tiers. For more info check - https://hello.atlassian.net/browse/TTC-15852
   * @param pricingPlan
   * @param maxUsersForCurrentOffering
   */
  const getMaxUsersForOrderEstimate = (
    pricingPlan: PricingPlan,
    maxUsersForCurrentOffering: number
  ): number | undefined | null => {
    const sortedTiers = [...defaultTo(get(pricingPlan, 'tiers'), [])].sort(
      (a, b) => defaultTo(get(a, 'floor'), 0) - defaultTo(get(b, 'floor'), 0)
    );
    // As there is a hard limit of 10 for the sub-items in the order-estimate response,
    // we are checking for products which have more than 10 tiers in the selected pricing plan.
    // And, if it has more than 10 tiers, then we will use the 10th tier's ceiling to set the max number of users.
    if (sortedTiers?.length > 10) {
      const tenthTier = sortedTiers?.[9];
      if (tenthTier?.ceiling) {
        return tenthTier?.ceiling;
      }
      // In case 10th tier's ceiling has null users, we will use the 9th tiers ceiling. Mostly impossible.
      return sortedTiers?.[8]?.ceiling;
    }
    // If the pricing plan doesn't have more than 10 tiers, we are very happy to
    // set the max number of users for the current offering as the max permissible number of users for the product.
    return maxUsersForCurrentOffering;
  };
  return {
    getMaxUsersForOrderEstimate,
  };
};
